import { TOKENS } from '@monthio/design-system/tokens'
import styled from 'styled-components'

export const ExplainerList = styled.ul`
	padding-inline-start: 24px;
	list-style-type: none;

	margin-block: ${TOKENS.space.s};
	font-size: 0.875rem;
	line-height: 1.25rem;

	> li + li {
		margin-top: ${TOKENS.space.xs};
	}
`

export const ExplainerListItem = styled.li`
	padding-left: 8px;
	line-height: 2;

	> svg {
		content: '';
		height: 24px;
		width: 24px;
		position: absolute;
		translate: -32px 4px;
	}
`
